import { useState } from "react";
import { useSelector } from "react-redux";

import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto";
import { ExpandableTextarea } from "../../../components/ExpandableTextarea/ExpandableTextarea";
import { RootState } from "../../../state/store";

type WorkOrderCellProps = {
  stoppage: StoppageDto
  handleWorkOrderChange: (stoppage: StoppageDto) => Promise<void>
}

const WorkOrderCell: React.FC<WorkOrderCellProps> = ({ stoppage, handleWorkOrderChange }) => {
  const isShiftLocked = useSelector((state: RootState) => state.shift.isLocked);
  const [textState, setTextState] = useState<string>(stoppage.workOrder || '');

  return (
    <div className="w-full">
      <ExpandableTextarea
        disabled={isShiftLocked}
        value={textState}
        placeholder="No Work Order"
        onChange={(e) => setTextState(e.target.value)}
        onSubmit={async () => {
          await handleWorkOrderChange(new StoppageDto({ ...stoppage, workOrder: textState }));
        }}
      />
    </div>
  )
}

export default WorkOrderCell